export default "__VITE_ASSET__Cc3sOKzy__"